import { queryOptions } from "@tanstack/react-query";
import type {
  FindPackageByIdOutputDto,
  FindPackagesOutputDto,
} from "@/app/lib/types/codegen";

import api from "../api/api";

export const tripQueryOptions = (tripId: string) =>
  queryOptions({
    queryKey: ["packages", tripId],
    queryFn: ({ signal }) =>
      api.get<FindPackageByIdOutputDto>(`/packages/packages/${tripId}`, {
        signal,
      }),
    select: (response) => response.data.data,
    throwOnError: false,
  });

type TripsQueryOptionsParams = {
  sortField?: "createdAt" | "name" | "price" | "position" | "durationInDays";
  sortOrder?: "ASC" | "DESC";
};

export const tripsQueryOptions = (params?: TripsQueryOptionsParams) => {
  const normalizedParams: TripsQueryOptionsParams = {
    sortField: "position",
    sortOrder: "ASC",
    ...params,
  };

  return queryOptions({
    queryKey: ["packages", normalizedParams],
    queryFn: ({ signal }) =>
      api.get<FindPackagesOutputDto>("/packages/packages", {
        signal,
        params: normalizedParams,
      }),
    select: (response) => response.data.data.packages,
    throwOnError: false,
  });
};
